import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Grid, Row, Col } from '@sm/wds-react';

import './main-heading.scss';

/**
 * @desc The main heading and subheading component
 * @param {string} headingText - The main heading.
 * @param {string} subheadingText - The subheading.
 */
const MainHeading = props => {
  const { headingText, subheadingText } = props;
  return (
    <Grid>
      <Row>
        <Col>
          <Typography
            variant="hero1"
            component="h1"
            className="sm-main-heading__hero-title"
            align="center"
          >
            {headingText}
          </Typography>
          <Typography
            component="section"
            variant="sectionTitle"
            align="center"
            className="sm-main-heading__hero-subtitle"
          >
            {subheadingText}
          </Typography>
        </Col>
      </Row>
    </Grid>
  );
};

MainHeading.propTypes = {
  headingText: PropTypes.string,
  subheadingText: PropTypes.string
};
MainHeading.defaultProps = {
  headingText: 'Plans for Teams and Organizations',
  subheadingText: 'Work smarter by creating and analyzing surveys as a team.'
};

export default MainHeading;
